export default "__VITE_ASSET__ef5bf6e5__"